export default __webpack_public_path__ + "static/media/apple.3ba03d90.svg";